import type {
  ConsolidatedDashboard,
  ReportDefinitionInfo,
  ReportExportFormat,
  ReportFilterSource,
  ReportResult,
} from '@ldembalagens/types';
import { api, downloadFile, type QueryParams } from '@/lib/api-client';

export const reportsApi = {
  list: () => api.get<ReportDefinitionInfo[]>('/reports'),
  options: (source: ReportFilterSource) =>
    api.get<{ value: string; label: string }[]>(`/reports/filter-options/${source}`),
  run: (key: string, query: QueryParams) => api.get<ReportResult>(`/reports/${key}`, query),
  export: (key: string, format: ReportExportFormat, query: QueryParams) =>
    downloadFile(`/reports/${key}/export`, { ...query, format }),
  consolidated: (query: { from?: string; to?: string }) =>
    api.get<ConsolidatedDashboard>('/dashboard/consolidated', query),
};

export const reportsKeys = {
  all: ['reports'] as const,
  list: ['reports', 'list'] as const,
  options: (source: string) => ['reports', 'options', source] as const,
  run: (key: string, q: object) => ['reports', 'run', key, q] as const,
  consolidated: (q: object) => ['dashboard', 'consolidated', q] as const,
};
